import fetch from "lib/fetch";
import type { MovingVehicleTypeInterface } from "types/reference";

type MovingVehicleTypeListResponse = { data: Array<MovingVehicleTypeInterface> };

export const getMovingVehicleTypesRequest = (languageCode: string) =>
    fetch.get<MovingVehicleTypeListResponse>(`reference/moving_vehicle_type/${languageCode}`);
